import { gql } from 'graphql-tag';
import { LISTING_FRAGMENT } from './Listing.fragments';

export const LISTING_QUERY = gql`
    query listing($listingId: Int!, $include: [ListingInclusion]) {
        listingDetails(id: $listingId, include: $include) {
            ... on ListingData {
                ...LISTING
            }

            ... on ListingResultError {
                errorCode
            }
        }
    }

    ${LISTING_FRAGMENT}
`;
